import { render, staticRenderFns } from "./MgmInvitedSSO.vue?vue&type=template&id=3deb27c6"
import script from "./MgmInvitedSSO.vue?vue&type=script&lang=js"
export * from "./MgmInvitedSSO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports